<template>
    <ob1-popin-modal2
        :id="modalId"
        :aria-labelledby="modalLabelId"
        @ob1-popin-modal-click="closePopin"
    >
        <div :id="modalLabelId" class="h4" v-html="messages.title" />
        <recovery-simulator
            ref="simulator"
            :shop="shop"
            :messages="messages"
            :modal-id="modalId"
            @update-recovery-simulation="updateRecoveryPrice"
        />
    </ob1-popin-modal2>
</template>

<script>
import RecoverySimulator from "./recoverysimulator/RecoverySimulator.vue";

export default {
    name: "MobileRecoverySimulatorModal",
    components: {RecoverySimulator},
    props: {
        modalId: {
            type: String,
            required: true,
        },
        shop: {
            type: String,
            required: true,
        },
        messages: {
            type: Object,
            required: true
        },
    },
    computed: {
        modalLabelId: function () {
            return this.modalId + "-label";
        }
    },
    mounted: function () {
        const $modal = $(`#${this.modalId}`);
        $modal.on("hidden.bs.modal", () => {
            this.closePopin();
        });
    },
    beforeDestroy: function () {
        const $modal = $(`#${this.modalId}`);
        $modal.off("hidden.bs.modal");
    },
    methods: {
        closePopin() {
            this.$refs.simulator.reset();
        },
        updateRecoveryPrice(priceInCents, model) {
            this.$emit('update-recovery-simulation', priceInCents, model);
        }
    }
}
</script>

<style lang="scss">
.modal {
    z-index: 10000001; // Pour se positionner la modale au-dessus de la barre de nav sticky des elcos.
}

.modal-backdrop { // Correspond au voile sous la modale.
    z-index: 10000000;
}
</style>
